export const getNotificationPermission = (): NotificationPermission => {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return 'denied';
  }
  return Notification.permission;
};

export const requestNotificationPermission = async (): Promise<NotificationPermission> => {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return 'denied';
  }
  return Notification.requestPermission();
};

export const showSystemNotification = async (title: string, options: NotificationOptions = {}): Promise<boolean> => {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return false;
  }

  if (Notification.permission !== 'granted') {
    return false;
  }

  try {
    const normalizedOptions: NotificationOptions = {
      requireInteraction: true,
      renotify: true,
      timestamp: Date.now(),
      ...options
    };

    if ('serviceWorker' in navigator) {
      const readyRegistration = await Promise.race([
        navigator.serviceWorker.ready,
        new Promise<ServiceWorkerRegistration | null>((resolve) => {
          window.setTimeout(() => resolve(null), 1500);
        })
      ]);

      const registration = readyRegistration || await navigator.serviceWorker.getRegistration();
      if (registration?.showNotification) {
        await registration.showNotification(title, normalizedOptions);
        return true;
      }
    }

    new Notification(title, normalizedOptions);
    return true;
  } catch (error) {
    console.error('Notification error:', error);
    return false;
  }
};
